import { useEffect, useState } from "react";
import api from "../api";
import EmailComposer from "./EmailComposer";

const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";
const STATUS = {
  in_attesa: ["🕐 In attesa", "#facc15"],
  invio: ["⏳ Invio in corso…", "#38bdf8"],
  inviata: ["✅ Inviata", "#39ff14"],
  errore: ["❌ Errore", "#fb7185"],
  annullata: ["🚫 Annullata", "#94a3b8"],
};

export default function ScheduledEmails() {
  const [rows, setRows] = useState(null);
  const [edit, setEdit] = useState(null);
  const [busy, setBusy] = useState("");
  const [msg, setMsg] = useState("");

  const load = () => api.get("/emails/scheduled").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  const openEdit = async (r) => {
    try { const d = await api.get(`/emails/scheduled/${r.id}`); setEdit(d.data); }
    catch (e) { setMsg(e.response?.data?.detail || e.message); }
  };
  const cancelRow = async (r) => {
    const q = r.status === "in_attesa" ? `Annullare l'invio programmato a ${r.to}?` : `Eliminare questa riga dall'elenco?`;
    if (!window.confirm(q)) return;
    try { await api.delete(`/emails/scheduled/${r.id}`); load(); }
    catch (e) { setMsg(e.response?.data?.detail || e.message); }
  };
  const sendNow = async (r) => {
    if (!window.confirm(`Inviare SUBITO l'email a ${r.to}?`)) return;
    setBusy(r.id); setMsg("");
    try {
      const res = await api.post(`/emails/scheduled/${r.id}/send-now`);
      setMsg(res.data.ok ? `✅ Inviata a ${r.to}.` : "❌ " + (res.data.error || "Invio fallito."));
    } catch (e) { setMsg("❌ " + (e.response?.data?.detail || e.message)); }
    finally { setBusy(""); load(); }
  };

  if (rows === null) return null;
  const pending = rows.filter((r) => r.status === "in_attesa").length;
  return (
    <div className="panel" style={{ marginBottom: 12 }} data-testid="scheduled-emails-panel">
      <div className="today-head">🕐 Email programmate {pending > 0 && <span className="nav-badge">{pending} in attesa</span>}</div>
      {rows.length === 0 ? (
        <p className="muted" style={{ fontSize: 13 }}>Nessuna email programmata. Nel composer trovi il pulsante "🕐 Programma invio" per scriverla ora e inviarla quando vuoi.</p>
      ) : (
        <div style={{ overflow: "auto" }}>
          <table style={{ width: "100%" }} data-testid="scheduled-emails-table">
            <thead><tr>
              <th>A</th><th>Oggetto</th><th style={{ width: 145 }}>Invio programmato</th>
              <th style={{ width: 190 }}>Stato</th><th style={{ width: 210 }}>Azioni</th>
            </tr></thead>
            <tbody>
              {rows.map((r) => {
                const [lbl, col] = STATUS[r.status] || [r.status, "#94a3b8"];
                return (
                  <tr key={r.id} data-testid={`sched-row-${r.id}`}>
                    <td>{r.to}{(r.cc || []).length > 0 && <span className="muted" style={{ fontSize: 11.5 }}> +{r.cc.length} cc</span>}</td>
                    <td>{r.subject || "(senza oggetto)"}{(r.attachments || []).length > 0 && <span className="muted"> 📎{r.attachments.length}</span>}</td>
                    <td>{fmtDT(r.scheduled_at)}</td>
                    <td>
                      <span style={{ color: col, fontWeight: 600, fontSize: 13 }}>{lbl}</span>
                      {r.status === "inviata" && <div className="muted" style={{ fontSize: 11.5 }}>il {fmtDT(r.sent_at)}</div>}
                      {r.status === "errore" && <div style={{ fontSize: 11.5, color: "#fb7185" }} title={r.error}>{(r.error || "").slice(0, 60)}…</div>}
                    </td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      {(r.status === "in_attesa" || r.status === "errore") && (
                        <>
                          <button className="btn sm" onClick={() => openEdit(r)} data-testid={`sched-edit-${r.id}`}>✏️ Modifica</button>{" "}
                          <button className="btn sm" onClick={() => sendNow(r)} disabled={busy === r.id} data-testid={`sched-sendnow-${r.id}`}>{busy === r.id ? "…" : "📤 Invia ora"}</button>{" "}
                        </>
                      )}
                      <button className="btn sm" onClick={() => cancelRow(r)} title={r.status === "in_attesa" ? "Annulla invio" : "Elimina riga"} data-testid={`sched-del-${r.id}`}>🗑</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
      {msg && <p className="muted" style={{ marginTop: 6, fontSize: 13 }} data-testid="scheduled-emails-msg">{msg}</p>}
      {edit && <EmailComposer scheduled={edit} onClose={() => setEdit(null)} onSent={() => { setEdit(null); load(); }} />}
    </div>
  );
}
